<script>
import {mapActions, mapGetters} from "vuex";
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import {formatDate, getPictureUrl } from "@/lib";
import RichText from "@/components/ui/RichText.vue";
import UpcomingEventDetails from "@/components/events/UpcomingEventDetails.vue";
import PastEventDetails from "@/components/events/PastEventDetails.vue";
import { metricEventTypes, metricParents } from "@/lib";

export default {
  name: "VeranstaltungDetails",
  methods: {
    ...mapActions('metrics', ['postHeartbeat']),
    formatDate,
    getPictureUrl
  },
  components: {
    UpcomingEventDetails,
    RichText,
    RightColumnGroup,
    PastEventDetails,
  },
  data: () => ({
    lat: undefined,
    lng: undefined,
    upcomingEvent: false,
  }),
  props: {
    id: Number,
  },
  async mounted() {
    if(!this.event) {
      await this.$router.push({ name: 'not-found' });
    }

    await this.postHeartbeat({
      name: this.event.Titel,
      type: metricEventTypes.PAGE_VISIT,
      parent: metricParents.EVENTS,
    });
    this.upcomingEvent = !this.event.SortKey || this.event.SortKey > new Date().getTime();


  },
  computed: {
    ...mapGetters('veranstaltungen', ['eventById']),
    event() {
      return this.eventById(this.id);
    },

    personsInCharge() {

      const persons = [this.event.Ansprechpartner];
      persons.push(...this.event.weitereAnsprechpartner);

      return persons.filter(p => p);
    },

  }
}
</script>

<template>
  <v-row no-gutters class="min-height-100">
    <v-col cols="12" md="8" class="new-wrapper pt-10">
      <div class="pa-5">
        <v-chip color="light-green lighten-1" x-small label class="material-typ-badge mr-2" v-if="event.Angemeldet">Angemeldet</v-chip>
      <v-chip color="grey lighten-1" x-small label class="material-typ-badge mr-2" v-if="event.SortKey">{{ formatDate(event.Termin.Datum) }}</v-chip>
        <v-chip color="grey lighten-1" x-small label class="material-typ-badge mr-2" v-else>Termin folgt</v-chip>
        <v-chip color="grey lighten-1" x-small label class="material-typ-badge">{{event.Adresse.Ort }}</v-chip>
      <div class="custom-header-text new-font-bold mb-5">{{ event.Titel }}</div>
      <v-carousel continuous cycle hide-delimiter-background hide-delimiters interval="7500" v-if="event.Bilder.length > 1">
        <v-carousel-item v-for="picture of event.Bilder" :key="picture.id">
          <v-img :src="getPictureUrl(picture)" :aspect-ratio="572/382" />
          <div class="black--text picture-caption">{{ picture.caption }}</div>
        </v-carousel-item>
      </v-carousel>
      <div v-else-if="event.Bilder.length === 1" class="mb-5">
        <v-img :aspect-ratio="572/382" :src="getPictureUrl(event.Bilder[0])" />
        <div class="black--text picture-caption">{{ event.Bilder[0].caption }}</div>
      </div>
      <rich-text :markdown-text="event.Text" />
      </div>
      <upcoming-event-details v-if="upcomingEvent" :event="event" />
      <past-event-details v-else :event="event" />
    </v-col>
    <v-col
        cols="12" md="4"
        class="contact_container pl-4"
    >
      <RightColumnGroup :content-object="{ personsInCharge }" />
    </v-col>
  </v-row>
</template>

<style scoped>
.yt-container > iframe {
  width: 100% !important;
  height: 100% !important;
}
</style>